import {
  applyUpdate,
  dismissUpdate,
  getUpdateState,
  subscribeToUpdates,
} from '@/modules/pwa/sw-update'
import { useCallback, useSyncExternalStore } from 'react'

export function useServiceWorkerUpdate() {
  const state = useSyncExternalStore(subscribeToUpdates, getUpdateState)

  const handleApplyUpdate = useCallback(async () => {
    await applyUpdate()
  }, [])

  const handleDismissUpdate = useCallback(() => {
    dismissUpdate()
  }, [])

  return {
    updateAvailable: state.updateAvailable,
    offlineReady: state.offlineReady,
    applyUpdate: handleApplyUpdate,
    dismissUpdate: handleDismissUpdate,
  }
}
